import { render, staticRenderFns } from "./hair-types-scalp-hair.vue?vue&type=template&id=16742074&"
import script from "./hair-types-scalp-hair.vue?vue&type=script&lang=js&"
export * from "./hair-types-scalp-hair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports